<template>
  <div :class="['status-message', statusType]">
    <div class="status-icon">{{ statusIcon }}</div>
    <div>
      <h3>{{ statusTitle }}</h3>
      <p>{{ statusMessage }}</p>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  status: {
    type: String,
    required: true
  },
  errorMessage: {
    type: String,
    default: ''
  }
});

const { t } = useI18n()

const STATUS_CONFIG = {
  running: {
    type: 'info',
    icon: '⏳',
    titleKey: 'simulation.statusMessage.running.title',
    messageKey: 'simulation.statusMessage.running.message'
  },
  queued: {
    type: 'info',
    icon: '⏰',
    titleKey: 'simulation.statusMessage.queued.title',
    messageKey: 'simulation.statusMessage.queued.message'
  },
  failed: {
    type: 'error',
    icon: '❌',
    titleKey: 'simulation.statusMessage.failed.title',
    messageKey: 'simulation.statusMessage.failed.message'
  }
}

const currentConfig = computed(() => {
  const normalized = String(props.status || 'failed').toLowerCase()
  const baseConfig = STATUS_CONFIG[normalized] || STATUS_CONFIG.failed
  const title = t(baseConfig.titleKey)
  const message =
    normalized === 'failed' && props.errorMessage
      ? props.errorMessage
      : t(baseConfig.messageKey)
  return {
    type: baseConfig.type,
    icon: baseConfig.icon,
    title,
    message
  }
})

const statusType = computed(() => currentConfig.value.type);
const statusIcon = computed(() => currentConfig.value.icon);
const statusTitle = computed(() => currentConfig.value.title);
const statusMessage = computed(() => currentConfig.value.message);
</script>

<style scoped>
.status-message {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 24px;
  border-radius: 8px;
  margin: 20px 0;
}

.status-message.info {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  color: #1890ff;
}

.status-message.error {
  background: #fff2f0;
  border: 1px solid #ffccc7;
  color: #ff4d4f;
}

.status-icon {
  font-size: 24px;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.8);
}

.status-message h3 {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
}

.status-message p {
  margin: 0;
  font-size: 14px;
  opacity: 0.8;
}
</style>
